export const sanitizeFilename = (name: string): string => {
  return name
    .replace(/[/:*?"<>|]+/g, ' ')
    .replace(/\s+/g, ' ')
    .trim()
}

export const downloadFile = async (url: string, filename: string): Promise<boolean> => {
  try {
    const response = await fetch(url)
    if (!response.ok) throw new Error('Failed to download file')
    const blob = await response.blob()
    const objectUrl = URL.createObjectURL(blob)

    const a = document.createElement('a')
    a.href = objectUrl
    a.download = filename
    a.rel = 'noopener'
    a.style.display = 'none'
    document.body.appendChild(a)
    a.click()
    document.body.removeChild(a)

    // Revoke the object URL after the tick to free memory
    setTimeout(() => URL.revokeObjectURL(objectUrl), 0)
    return true
  } catch (error) {
    console.error('Download failed:', error)
    // You might want to show a user-facing error message here
    return false
  }
}
